(function () {
  const root = document.querySelector('[data-sbp-root]');
  if (!root) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const PET_FALLBACKS = {
    dog: 'https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&w=1200&q=85',
    cat: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&w=1200&q=85',
    rabbit: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?auto=format&fit=crop&w=1200&q=85',
    bird: 'https://images.unsplash.com/photo-1552728089-57bdde30beb3?auto=format&fit=crop&w=1200&q=85',
    reptile: 'https://images.unsplash.com/photo-1760634871892-8b2d3b52ace6?auto=format&fit=crop&w=700&q=80',
    fish: 'https://images.unsplash.com/photo-1520302630591-fd1c66edc19d?auto=format&fit=crop&w=700&q=80',
    'small pet': 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?auto=format&fit=crop&w=700&q=80',
    horse: 'https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?auto=format&fit=crop&w=1000&q=80',
    farm: 'https://images.unsplash.com/photo-1500595046743-cd271d694d30?auto=format&fit=crop&w=1000&q=80',
  };

  const BROKEN_IDS = ['1574158622682-6b4a842b6b74', '1518796251428'];

  function petFallbackFor(img) {
    const alt = (img.getAttribute('data-sbp-alt') || img.getAttribute('alt') || '').toLowerCase();
    if (PET_FALLBACKS[alt]) return PET_FALLBACKS[alt];
    return Object.keys(PET_FALLBACKS).find((key) => alt.includes(key))
      ? PET_FALLBACKS[Object.keys(PET_FALLBACKS).find((key) => alt.includes(key))]
      : '';
  }

  root.querySelectorAll('img.sbp-img').forEach((img) => {
    const ph = img.closest('.ph');
    const done = () => img.classList.add('is-loaded');

    BROKEN_IDS.forEach((id) => {
      if (img.src.includes(id)) {
        const fb = petFallbackFor(img);
        if (fb) img.src = fb;
      }
    });

    const onError = () => {
      if (img.dataset.fallbackUsed === '1') {
        done();
        return;
      }
      const assetFb = img.getAttribute('data-fallback-src');
      const petFb = petFallbackFor(img);
      const next = assetFb || petFb;
      if (next && img.src !== next) {
        img.dataset.fallbackUsed = '1';
        img.addEventListener('load', done, { once: true });
        img.src = next;
        return;
      }
      done();
    };

    if (img.complete && img.naturalWidth > 0) done();
    else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', onError, { once: true });
    }
  });

  root.querySelectorAll('#sbp-pills .pill').forEach((pill) => {
    pill.addEventListener('click', (e) => {
      const id = pill.getAttribute('href');
      const card = id ? root.querySelector(id) : null;
      if (!card) return;
      e.preventDefault();
      card.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      card.classList.remove('pulse');
      void card.offsetWidth;
      card.classList.add('pulse');
    });
  });

  const items = root.querySelectorAll('[data-reveal]');
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('in'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach((el) => io.observe(el));
  }
})();
